import React from 'react'
import VipIcon from '../../../form/component/VipIcon'
import Table from '../../../form/component/Table'
import {renderProcessName, renderRoleName, renderTaskName,} from '../../util/names'
import {renderStoreName} from '../../../store/util/renderStoreName'
import renderLanguageFamily from '../../../internationalization/renderLanguageFamily'
import {renderCountryName} from '../../../customer/util/names'
import {COUNTRY_CODE_LIST, LANGUAGE_LIST} from '../../../internationalization/const'
import {renderAppointmentReason, renderAppointmentType} from "../../../appointment/util/names";
import {APPOINTMENT_REASON_LIST, APPOINTMENT_TYPE_LIST} from "../../../appointment/state/const";

export default (canSeeCustomerNames, isTablet, currentUserId) => {
    const columnList = []

    if (!isTablet) {
        columnList.push({
            property: 'vip',
            header: 'VIP',
            width: '45',
            renderer: processInstance => {
                return <VipIcon active={processInstance.vip}/>
            },
        })
        columnList.push({
            property: 'created',
            header: 'Created',
            comparator: Table.dateComparator('created'),
            renderer: Table.dateTimeRenderer('created'),
        })
    }

    columnList.push({
        property: 'due',
        header: 'Due',
        comparator: Table.dateComparator('due'),
        renderer: Table.dateTimeRenderer('due'),
    })

    if (!isTablet) {
        columnList.push({
            property: 'processName',
            header: 'process Name',
            renderer: processInstance => {
                return renderProcessName(processInstance.processName)
            },
            sortValue: processInstance => {
                return renderProcessName(processInstance.processName)
            },
        })
    }

    columnList.push({
        property: 'name',
        header: 'taskname',
        renderer: processInstance => {
            return renderTaskName(processInstance.name)
        },
        sortValue: processInstance => {
            return renderTaskName(processInstance.name)
        },
    })

    columnList.push({
        property: 'appointmentType',
        header: 'Appointment Type',
        renderer: processInstance => {
            return renderAppointmentType(processInstance.appointmentType)
        },
        filterType: 'select',
        filterOptions: APPOINTMENT_TYPE_LIST.map(appointmentType => ({
            id: appointmentType.id,
            value: appointmentType.value,
        })),
    })

    columnList.push({
        property: 'appointmentReason',
        header: 'Reason',
        renderer: processInstance => {
            return renderAppointmentReason(processInstance.appointmentReason)
        },
        filterType: 'select',
        filterOptions: APPOINTMENT_REASON_LIST.map(appointmentReason => ({
            id: appointmentReason.id,
            value: appointmentReason.value,
        })),
    })

    columnList.push({
        property: 'role',
        header: 'Role',
        renderer: processInstance => {
            return renderRoleName(processInstance.role)
        },
        sortValue: processInstance => {
            return renderRoleName(processInstance.role)
        },
    })

    if (canSeeCustomerNames) {
        columnList.push({
            property: 'processDisplayName',
            header: 'Name',
        })
    }

    columnList.push({
        property: 'complexity',
        header: 'Complexity',
    })
    if (!isTablet) {
        columnList.push({
            property: 'priority',
            header: 'Priority',
        })
        columnList.push({
            property: 'reference',
            header: 'Reference',
        })
        columnList.push({
            property: 'customerReference',
            header: 'Customer',
        })
    }
    columnList.push({
        property: 'status',
        header: 'Status',
        renderer: task => {
            if (task.assignedToUserId === currentUserId) {
                return 'my task ' + task.status
            }
            if (task.assignedToUserId !== null) {
                return 'assigned ' + task.status
            }
            return task.status
        },
    })
    if (!isTablet) {
        columnList.push({
            property: 'store',
            header: 'Store',
            renderer: processInstance => {
                return renderStoreName(processInstance.store)
            },
        })
        columnList.push({
            property: 'dealOwner',
            header: 'DealOwner',
        })
        columnList.push({
            property: 'language',
            header: 'Language',
            renderer: renderLanguageFamily,
            filterType: 'select',
            filterOptions: LANGUAGE_LIST.map(entry => ({
                id: entry.value,
                value: entry.value,
            })).filter(entry => (entry.id !== '')),
        })
    }
    columnList.push({
        property: 'countryCode',
        header: 'Country',
        renderer: processInstance => {
            return renderCountryName(processInstance.countryCode)
        },
        filterType: 'select',
        filterOptions: COUNTRY_CODE_LIST.map(country => ({
            id: country.value,
            value: country.value,
        })),
    })
    columnList.push({
        property: 'followUpType',
        header: 'Follow-up type',
        renderer: Table.followUpTypeRenderer('followUpType'),
    })
    columnList.push({
        property: 'treatmentPlanDeadline',
        header: 'TP Deadline',
        comparator: Table.dateComparator('treatmentPlanDeadline'),
        renderer: Table.dateTimeRenderer('treatmentPlanDeadline'),
    })

    return columnList
}



// WEBPACK FOOTER //
// ./src/modules/process/component/task-list/tasklist-column-list.js